import { Breakpoints, css, CTA, styled, ThemeDefinition } from '@volkswagen-onehub/components-core';

export const NoVehicleInteractiveCardContainer = styled.div`
  ${({ theme }: { theme: ThemeDefinition }) => {
    return css`
      align-items: center;
      background: ${theme.colors.background.primary};
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static350};
      justify-content: center;
      padding: ${theme.size.static350} 0;

      @media (min-width: ${Breakpoints.b560}px) {
        padding: ${theme.size.static350} ${theme.size.static400};
        border-radius: 12px;
        flex: 1 1 0;
        min-width: 0;
        width: 100%;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding: ${theme.size.static400};
      }
    `;
  }}
`;

export const NoVehicleInteractiveCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const NoVehicleInteractiveCTAContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  flex-wrap: wrap;
  ${({ theme }) => {
    return `
      gap: ${theme.size.static250};
    `;
  }}
`;

export const NoVehicleInteractiveCTA = styled(CTA)`
  /* Side by side with equal widths; stack only when a label no longer fits */
  min-width: max-content;
  flex: 1 1 0;

  @media (min-width: ${Breakpoints.b560}px) {
    min-width: 180px;
    flex: 1 0 0;
  }

  button:hover svg path {
    fill: currentColor;
  }
`